export function replacePathname(url: URL, pathname: string) {
  const currentUrl = new URL(url)
  currentUrl.pathname = pathname

  return currentUrl
}

function removeParams(searchParams: URLSearchParams, params: string[] | string): URLSearchParams {
  const nextParams = new URLSearchParams(searchParams)
  if (Array.isArray(params)) {
    params.forEach(param => {
      nextParams.delete(param)
    })
  } else {
    nextParams.delete(params)
  }
  return nextParams
}

export function stripQueryParams(url: URL, queryParams: string[] | string): URL {
  const next = new URL(url)
  next.search = removeParams(next.searchParams, queryParams).toString()
  return next
}

export function filterQueryParams(
  searchParams: URLSearchParams,
  params: string[] | string,
): URLSearchParams {
  return removeParams(searchParams, params)
}

export function stripDomain(url: URL) {
  return url.pathname + url.search + url.hash
}

export function replaceUrl(url: URL) {
  window.history.replaceState(null, '', url.toString())
}

export const addTrailingSlashToUrl = (url: string) => {
  return url.slice(-1) === '/' ? url : `${url}/`
}

export const addQueryToUrl = (url: string, query: string) => {
  return query ? `${addTrailingSlashToUrl(url)}?${query}` : url
}
